import { Container, Footer, TrophyMark } from '@tt/design-system';
import type { ReactNode } from 'react';

type AuthLayoutProps = {
  children: ReactNode;
};

/**
 * Layout do login — fundo cheio, sem header de app.
 * Mantém só a marca centralizada no topo + o conteúdo cerimonial.
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <>
      <div className="relative min-h-screen overflow-hidden bg-night text-parchment">
        <div className="pointer-events-none absolute inset-0 bg-stadium-glow" aria-hidden="true" />
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-stadium-floor"
          aria-hidden="true"
        />

        <header className="relative z-10 py-10">
          <Container size="narrow" className="flex items-center justify-center">
            <a
              href="/"
              className="flex items-center gap-3"
              aria-label="Touch the Trophy — Início"
            >
              <TrophyMark variant="filled" size="sm" />
              <div className="text-center">
                <p className="font-display text-base text-parchment">Touch the Trophy</p>
                <p className="font-mono text-[10px] uppercase tracking-stamp text-champagne">
                  Eternalize Tech
                </p>
              </div>
            </a>
          </Container>
        </header>

        <main
          id="main"
          className="relative z-10 flex min-h-[70vh] items-start justify-center pb-24 pt-4 sm:pt-12"
        >
          {children}
        </main>
      </div>
      <Footer compact />
    </>
  );
}
